"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "macerata": {
    "c755832b": [{
      "hkey": "a13c2d41",
      "slug": "macerata",
      "name": "Macerata",
      "primary": true,
      "skipSearch": false
    }],
    "frazioni": [{
      "hkey": "a13c2d41",
      "slug": "macerata",
      "name": "Macerata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a052bf45": [{
      "hkey": "477ad144",
      "slug": "corneto",
      "name": "Corneto",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "477ad144",
      "slug": "corneto",
      "name": "Corneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "macerata"
    }],
    "50e3111e": [{
      "hkey": "0cafd9c8",
      "slug": "cavour-fontescodella",
      "name": "Cavour-Fontescodella",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "367daf5c",
      "slug": "rione-marche-tribunale",
      "name": "Rione Marche-Tribunale",
      "primary": false,
      "skipSearch": false
    }],
    "semicentrale": [{
      "hkey": "0cafd9c8",
      "slug": "cavour-fontescodella",
      "name": "Cavour-Fontescodella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "macerata"
    }]
  }
};
exports["default"] = _default;